import { fromJS, List, Record } from 'immutable';
import { DateTime } from 'luxon';

import AddressRecord from './address';
import { normalizePhone } from '../lib/utils/formatters';
import { convertRawValues } from '../lib/utils/record_utils';
import BeneficialOwnerRecord from './beneficial_owner';

export default class ApplicationRecord extends Record({
  id: null,
  _type: '',
  created_at: null,
  business_type: '',
  is_authorized_signer: true,
  first_name: '',
  last_name: '',
  ein: '',
  email: '',
  phone: '',
  business_address: new AddressRecord(),
  business_phone: '',
  birthdate: '',
  company_name: '',
  dba: '',
  raw_annual_revenue: '',
  personal_address: new AddressRecord(),
  ssn: '',
  status: '',
  tier: '',
  gross_annual_revenue: '',
  interest_percent: 0,
  beneficial_owners: fromJS([]),
  are_additional_owners_confirmed: false,
  applied_with_merchant: '',
  approved_credit_limit: '',
  previous_tcl: '',
  sells_restricted_products: false,
  has_authorized_purchaser: false,
  reasons: [],
  ofac_status: '',
  fico_score: '',
  applicant_ip_address: '',
  equifax_request_date: '',
  latest_submission_date: '',
  original_submission_date: '',
  pended_at: '',
  phone_change_attempts: 0,
  modelshop_decision: null,
  magi_decision: null,
}) {
  constructor(data) {
    data = convertRawValues(data);

    if (data.get('business_address')) {
      data = data.set(
        'business_address',
        new AddressRecord(data.get('business_address')),
      );
    }

    if (data.get('personal_address')) {
      data = data.set(
        'personal_address',
        new AddressRecord(data.get('personal_address')),
      );
    }

    if (data.get('birthdate')) {
      const birthdate = DateTime.fromISO(data.get('birthdate')).toLocaleString(
        DateTime.DATE_SHORT,
      );

      if (birthdate.isValid) {
        data = data.set('birthdate', birthdate.toFormat('yyyy-MM-dd'));
      }
    }

    if (data.get('phone'))
      data = data.set('phone', normalizePhone(data.get('phone')));
    if (data.get('business_phone'))
      data = data.set(
        'business_phone',
        normalizePhone(data.get('business_phone')),
      );

    const owners = [];
    if (data.has('beneficial_owners')) {
      data.get('beneficial_owners').forEach((bo) => {
        owners.push(new BeneficialOwnerRecord(bo));
      });
    }
    data = data.set('beneficial_owners', List(owners));

    super(data);
  }

  get applicant_full_name() {
    return `${this.first_name || ''} ${this.last_name || ''}`.trim();
  }
}
